<template>
  <div data-cy="time-display" class="text-label">{{ formattedTime }}</div>
</template>
<script setup lang="ts">
import { useNow } from "@vueuse/core";
import { computed } from "vue";

import { storeToRefs } from "pinia";

import { useCallsStore } from "@/stores/calls";

const { callStartedAt } = storeToRefs(useCallsStore());

const now = useNow({ interval: 1_000 });

const formattedTime = computed(() => {
  if (!callStartedAt.value) {
    return "00:00";
  }
  const elapsed = Math.floor(
    (now.value.getTime() - callStartedAt.value) / 1_000
  );
  return new Date(Math.max(0, elapsed) * 1_000).toISOString().slice(14, 19);
});
</script>
